import {
  DateRangeFilter,
  FilterProps,
  MultiDynamicOptionsCreatorFilter,
  MultiDynamicOptionsFilter,
  MultiStaticOptionFilter,
  PossibleFilters,
  PriceRangeFilter,
  PriceRangeFilterV2,
  RadioButtonsFilter,
} from '../../Crud/filters/sharedBetweenFilters/types';
import { IFilterHelperFactory } from './filter-factory.types';
import DateRangeFilterHelper from './helpers/date-range-filter.helper';
import DynamicCreatorFilterHelper from './helpers/dynamic-creator-filter.helper';
import DynamicFilterHelper from './helpers/dynamic-filter.helper';
import NumberRangeFilterHelper from './helpers/number-range-filter.helper';
import RadioFilterHelper from './helpers/radio-filter.helper';
import StaticFilterHelper from './helpers/static-filter.helper';

class FilterFactory {
  getFactory(filter: FilterProps): IFilterHelperFactory {
    const factories: Record<PossibleFilters, IFilterHelperFactory | undefined> = {
      [PossibleFilters.OPTIONS_SELECTOR_WITH_STATIC_DATA]: new StaticFilterHelper(
        filter as MultiStaticOptionFilter,
      ),
      [PossibleFilters.OPTIONS_SELECTOR_WITH_DYNAMIC_DATA]: new DynamicFilterHelper(
        filter as MultiDynamicOptionsFilter,
      ),
      [PossibleFilters.OPTIONS_SELECTOR_CREATOR]: new DynamicCreatorFilterHelper(
        filter as MultiDynamicOptionsCreatorFilter,
      ),
      [PossibleFilters.DATE_RANGE]: new DateRangeFilterHelper(filter as DateRangeFilter),
      [PossibleFilters.NUMBER_RANGE]: new NumberRangeFilterHelper(filter as PriceRangeFilter),
      [PossibleFilters.NUMBER_RANGE_V2]: new NumberRangeFilterHelper(filter as PriceRangeFilterV2),
      [PossibleFilters.SEARCH_BAR]: undefined,
      [PossibleFilters.RADIO]: new RadioFilterHelper(filter as RadioButtonsFilter),
    };
    const factory = factories[filter.type];

    if (!factory) {
      throw new Error(`factory for filter ${filter.type} not implemented yet`);
    }

    return factory;
  }
}

export default FilterFactory;
